var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-menu"},[_c('div',{staticClass:"tabs-menu__inner"},_vm._l((_vm.items),function(name,id,index){return _c('div',{key:id,staticClass:"tabs-menu__button",class:{
        'tabs-menu__button--active': _vm.activeItem === id,
        'tabs-menu__button--first': index === 0,
        'tabs-menu__button--last': index === Object.keys(_vm.items).length - 1
      },attrs:{"data-item":id,"title":_vm.getTabTooltip(id)},on:{"click":function($event){return _vm.$emit('activeTab', id)}}},[_vm._v("\n      "+_vm._s(name)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }